import getSeparator from "@/util/getSeperator";

export const DECIMAL_SEPERATOR = getSeparator("nl", "decimal");
export const NUMBER_PATTERN = `\\s*(?<value>([1-9]+[0-9]*)(\\${DECIMAL_SEPERATOR}[0-9]+)?)\\s*`;
